import React, { useState, useEffect, useRef } from 'react';
import { Field as Fieldmik, FieldArray, ErrorMessage } from 'formik';
import { Form as FormUi, Input, Button, Dropdown, Grid, Header, Table, Icon } from 'semantic-ui-react';

// import { DateData } from '../formikInput/date';
import { MyInput, MyNormalInput } from '../apiInputComponent/myInput';

import ProductSKUDropdown from '../apiInputComponent/productSKUDropdown';
import ShowTotal from './showTotal';
import FinalTotal from './finalTotal';

const AddProduct = ({ handleChange, billmode, masterState, vendorStateId, viewMode, ...props }) => {

  const [productData, setProductData] = useState([])


  useEffect(() => {
  }, [props?.jobcardTypeName])

  const getProductData = childData => {
    setProductData(childData);
  }



  return (
    <div className="ui form">
      <FieldArray
        name="productDetails">
        {({ push, remove, replace, form }) => {

          const { inititalValues, values, setFieldValue } = form
          const { productDetails } = values

          values.calulatedRate = Math.random();

          if (props?.jobcardTypeName == 'FUEL' && productDetails.length <= 1) {
            let prductFuel = {}
            let fuelDataAdd = {}
            let addedProductObject;

            if (props?.jobcardTypeName == 'FUEL' && productData != null && productData != undefined) {


              productData.forEach(element => {
                if (element.psDescription == "FUEL") {
                  prductFuel = element;

                  addedProductObject = productData.filter(e => {
                    return e.psId === element.psId
                  })

                  fuelDataAdd = {
                    productCode: element.psCode, productName: element.psId, productPlaceholder: element.psDescription,
                    startDate: '', endDate: '',
                    hsnCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].HSNCode : "",
                    sacCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].SACCode : "",
                    quantity: '', rate: '', discount: '', discountType: '1',
                    iGstPercent: vendorStateId == masterState ? "" : addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage,
                    cGstPercent: vendorStateId == masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage / 2 : "",
                    sGstPercent: vendorStateId == masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage / 2 : "",
                    iGst: '', cGst: '', sGst: '', amount: ''
                  }
                }
              });

              //productDetails.pop();
              //productDetails.unshift(fuelDataAdd)

              productDetails[0].productName = fuelDataAdd.productName
              productDetails[0].productCode = fuelDataAdd.productCode
              productDetails[0].productPlaceholder = fuelDataAdd.productPlaceholder

            }

          }


          let productSelectedArray = []

          productDetails.map((product, index) => {

            let temp = {}
            temp.productName = product.productName

            productSelectedArray[index] = temp
          })

          const handleUpdateProduct = (e, data, index, object) => {
            const { setFieldValue } = form

            let addedProductObject = productData.filter(e => {
              return e.psId === data.value
            })

            setFieldValue(data.name, data.value).then(() => {
              replace(index, {
                productName: data.value,
                productCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].psCode : "",
                hsnCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].HSNCode : "",
                sacCode: addedProductObject && addedProductObject[0] ? addedProductObject[0].SACCode : "",
                quantity: object.quantity,
                discountType: object.discountType,
                discount: "",
                rate: addedProductObject && addedProductObject[0] ? addedProductObject[0].sellingPrice : "",
                iGstPercent: vendorStateId === masterState ? "" : addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage,
                cGstPercent: vendorStateId === masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage / 2 : "",
                sGstPercent: vendorStateId === masterState ? addedProductObject && addedProductObject[0] && addedProductObject[0].gstPercentage / 2 : "",

              })


            })
          }

          return (
            <>
              <Table unstackable size="large" compact="very" className="w3-small">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className="w3-white" colSpan="13">  <label className="labelName w3-text-blue">Product/Service Details</label></Table.HeaderCell>
                  </Table.Row>
                  <Table.Row >
                    <Table.HeaderCell className="labelName p-bold-600">Product Details</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">HSN/SAC Code</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">IGST%</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">IGST(₹)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">CGST</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">CGST(₹)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">SGST</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">SGST(₹)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                    {viewMode ? null :
                      <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell>
                    }
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {productDetails.map((object, index) => {

                    const discountOptions = [
                      { key: '1', text: '₹', value: '1' },
                      { key: '2', text: '%', value: '2' },
                    ];

                    let tempAmount = '';
                    if (object.discount > 0 && object.discountType == "1") {
                      let finalRate = +object.rate * +object.quantity
                      tempAmount = +finalRate - +object.discount
                    } else {
                      let finalRate = +object.rate * +object.quantity
                      tempAmount = +finalRate - +object.discount
                    }

                    object.iGst = +object.iGstPercent / 100 * +tempAmount
                    object.cGst = +object.cGstPercent / 100 * +tempAmount
                    object.sGst = +object.sGstPercent / 100 * +tempAmount

                    object.taxableAmount = +tempAmount

                    object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst


                    return (
                      <Table.Row verticalAlign="middle" key={index} >
                        <React.Fragment>
                          <Table.Cell wid>
                            <Fieldmik
                              disabled={viewMode || (props?.jobcardTypeName == 'FUEL' && index == 0)}
                              component={ProductSKUDropdown}
                              handleUpdateProduct={handleUpdateProduct}
                              productIndex={index}
                              productObject={object}
                              getProductData={getProductData}
                              psType={props?.jobcardTypeName && props.jobcardTypeName == 'SERVICES' ? 2 : 1}
                              placeholder={object?.productName ? (object?.productPlaceholder ? object.productPlaceholder : object.productName) : "Product Name"}
                              name={`productDetails[${index}].productName`}
                              style={{ width: '200px' }}
                              value={object.productName ? object.productName : ''}
                              productSelectedArray={productSelectedArray}
                              selectedProductEdit={object.productName}
                            />
                            <ErrorMessage name={`productDetails[${index}].productName`}>
                              {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                            </ErrorMessage>
                          </Table.Cell>

                          <Table.Cell width={2}>{object.hsnCode || object.sacCode ? `${object.hsnCode, object.sacCode}` : ''}</Table.Cell>
                          <Table.Cell style={{ minWidth: '80px' }}>
                            <Fieldmik
                              readOnly={viewMode}
                              component={MyNormalInput}
                              type="number"
                              value={object.quantity === 0 ? '' : object.quantity}
                              min="1"
                              autoComplete="off"
                              name={`productDetails[${index}].quantity`}
                              size="small"
                            />
                            <ErrorMessage name={`productDetails[${index}].quantity`}>
                              {error => <strong className="w3-text-red w3-tiny font-weight-bold">
                                {error.includes('NaN') ? 'Quantity is required.' : error}
                              </strong>}
                            </ErrorMessage>
                          </Table.Cell>
                          <Table.Cell style={{ minWidth: '100px' }}>
                            <Fieldmik
                              readOnly={viewMode}
                              component={MyNormalInput}
                              type="number"
                              min="0"
                              value={object.rate === 0 ? 0 : object.rate}
                              autoComplete="off"
                              name={`productDetails[${index}].rate`}
                              size="small"
                            />
                            <p>
                              <ErrorMessage name={`productDetails[${index}].rate`}>
                                {error => <strong className="w3-text-red w3-tiny font-weight-bold">
                                  {error.includes('NaN') ? 'Rate is required.' : error}
                                </strong>}
                              </ErrorMessage>
                            </p>
                          </Table.Cell>
                          <Table.Cell style={{ minWidth: '124px' }}>
                            <Fieldmik readOnly={viewMode} style={{ width: '60%' }} type="number" component={MyNormalInput} value={object.discount === 0 ? 0 : object.discount} name={`productDetails[${index}].discount`} size="small"
                              label={<Dropdown disabled={viewMode} placeholder={object.discountType === 2 ? '%' : "₹"} options={discountOptions} defaultValue={object.discountType} name={`productDetails[${index}].discountType`}
                                onChange={
                                  (value, data) => {
                                    object.discountType = data.value;
                                    setFieldValue(`productDetails[${index}].discountType`, data.value)
                                  }}
                              />}
                              labelPosition="right" className="tableinput" />
                          </Table.Cell>
                          <Table.Cell>{object.iGstPercent ? `${object.iGstPercent}%` : '0%'}</Table.Cell>
                          <Table.Cell>{object.iGst ? object.iGst.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell>{object.cGstPercent ? `${object.cGstPercent}%` : '0%'}</Table.Cell>
                          <Table.Cell>{object.cGst ? object.cGst.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell>{object.sGstPercent ? `${object.sGstPercent}%` : '0%'}</Table.Cell>
                          <Table.Cell>{object.sGst ? object.sGst.toFixed(2) : '0'}</Table.Cell>
                          <Table.Cell>{object.amount ? object.amount.toFixed(2) : '0'}</Table.Cell>
                          {viewMode ? null :
                            <Table.Cell hidden={index > 0 && !viewMode ? false : true} textAlign="right">
                              <Button onClick={() => remove(index)} type="button" basic size="mini" icon>
                                <Icon className="overhere" color="red" name="trash" />
                              </Button>
                            </Table.Cell>
                          }
                        </React.Fragment>

                      </Table.Row>
                    )
                  }
                  )}
                </Table.Body>
              </Table>

              <Grid columns={3}>
                <Grid.Row className="p-2">
                  <Grid.Column width={10}>
                    {!viewMode ?
                      <Button className="ml-2" type="button" onClick={() => push({ productName: '', startDate: '', endDate: '', hsnCode: '', sacCode: '', quantity: 1, rate: '', discount: '', discountType: '1', iGstPercent: '', iGst: '', cGstPercent: '', cGst: '', sGstPercent: '', sGst: '', amount: '' })} size="mini" basic color="blue">
                        + Add Product
                      </Button>
                      :
                      ""
                    }
                  </Grid.Column>
                  <Grid.Column>
                    {billmode ?
                      <>
                        <Grid.Row>
                          <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New PO Total</Header>
                          <Header floated="right" as="label" className="labelName" size="tiny">₹ {isNaN(values.manualPoAddedTotal) ? "0.00" : values.manualPoAddedTotal}</Header>
                        </Grid.Row>
                        <Grid.Row>
                          <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active PO Total</Header>
                          <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.activePoAddedTotal}</Header>
                        </Grid.Row>
                      </>
                      :
                      ""
                    }
                    <Grid>
                      <Grid.Row columns={2} >
                        <Grid.Column width="8">
                          <Header className="labelName" size="tiny">Sub Total</Header>
                        </Grid.Column>
                        <Grid.Column>
                          <ShowTotal subTotal={values.subTotal} values={values} />
                          {/* <Header className="labelName" size="tiny">₹ {values.subTotal ? values.subTotal : ''}</Header> */}
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width="8">
                          <Header className="labelName" size="tiny">Adjustment</Header>
                        </Grid.Column>
                        <Grid.Column width='8'>
                          <Fieldmik
                            readOnly={viewMode}
                            component={MyNormalInput}
                            type="number"
                            autoComplete="off"
                            name={`adjustmentAmount`}
                            size="small"
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width="8">
                          <Header className="labelName p-bold-600" size="tiny">Total</Header>
                        </ Grid.Column>
                        <Grid.Column width="8">
                          <FinalTotal finalAmount={+values.finalAmount} adjustmentAmt={+values.adjustmentAmount} subTotal={+values.subTotal} values={values} />
                          {/* <Header className="labelName" size="tiny">₹ {values.finalAmount ? values.finalAmount : ''}</Header> */}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </>
          )
        }
        }
      </FieldArray>
    </div>
  )
}

export default AddProduct











